export default __webpack_public_path__ + "static/media/e_wdt_c_5.dd84ed76.mp3";